import { IEnumeration } from 'utility-js-enumeration';

angular.module('capability-ng-conversations').factory('ConversationThreadStatusEnum', (Enumeration: IEnumeration) => {
  return Enumeration('ConversationThreadStatusEnum', {
    READ: 'READ',
    UNREAD: 'UNREAD',
    FLAGGED: 'FLAGGED'
  });
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-conversations/src/types/conversation_thread_status_enum.ts